import $  from 'jquery';

function setSlider() {
    // $('.product-slider-wrapper').each(function () {
    //     let prev = $(this).find('.js-prev');
    //     let next = $(this).find('.js-next');
    //     let slider = $(this).find('.product-slider');
    //
    //     slider.slick({
    //         infinite: true,
    //         speed: 300,
    //         slidesToShow: 4,
    //         slidesToScroll: 1,
    //         prevArrow: prev,
    //         nextArrow: next,
    //         responsive: [
    //             {
    //                 breakpoint: 1024,
    //                 settings: {
    //                     slidesToShow: 3,
    //                     slidesToScroll: 3,
    //                     infinite: true,
    //                     dots: true
    //                 }
    //             },
    //             {
    //                 breakpoint: 600,
    //                 settings: {
    //                     slidesToShow: 2,
    //                     slidesToScroll: 2
    //                 }
    //             },
    //             {
    //                 breakpoint: 480,
    //                 settings: {
    //                     slidesToShow: 1,
    //                     slidesToScroll: 1
    //                 }
    //             }
    //         ]
    //     });
    //     let sliderHeight = $(this).find('.slick-slide').innerHeight();
    //     $(this).find('.slick-slide').each(function () {
    //         $(this).css('height', sliderHeight + 'px');
    //     })
    // })

}

function setHero() {
    $('.js-hero').slick({
        arrows: false,
        autoplay: false,
        infinite: true,
        speed: 300,
        slidesToShow: 1,
        slidesToScroll: 1,
    });
}

export {setSlider, setHero}